module.exports = __webpack_public_path__ + "img/banner2.cf16b584.jpg";